import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { colors } from 'ui/theme/colors';

export const EmptyStateImages = ({ height = 88, width = 89, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 89 88" {...props}>
    <path
      d="M0.5 44C0.5 49.7782 1.63809 55.4997 3.8493 60.8381C6.06051 66.1764 9.30152 71.0269 13.3873 75.1127C17.4731 79.1985 22.3236 82.4395 27.6619 84.6507C33.0003 86.8619 38.7218 88 44.5 88C50.2782 88 55.9997 86.8619 61.3381 84.6507C66.6764 82.4395 71.5269 79.1985 75.6127 75.1127C79.6985 71.0269 82.9395 66.1764 85.1507 60.8381C87.3619 55.4997 88.5 49.7782 88.5 44C88.5 38.2218 87.3619 32.5003 85.1507 27.1619C82.9395 21.8236 79.6985 16.9731 75.6127 12.8873C71.5269 8.80152 66.6764 5.56051 61.3381 3.3493C55.9997 1.13809 50.2782 0 44.5 0C38.7218 0 33.0003 1.13809 27.6619 3.3493C22.3236 5.56051 17.4731 8.80152 13.3873 12.8873C9.30152 16.9731 6.06051 21.8236 3.8493 27.1619C1.63809 32.5003 0.5 38.2218 0.5 44Z"
      fill={colors.grey5}
    />
    <path
      d="M31.1963 77.275C31.1963 77.7126 32.4711 78.1323 34.7403 78.4417C37.0095 78.7512 40.0872 78.925 43.2963 78.925C46.5054 78.925 49.5831 78.7512 51.8523 78.4417C54.1215 78.1323 55.3963 77.7126 55.3963 77.275C55.3963 76.8374 54.1215 76.4177 51.8523 76.1083C49.5831 75.7988 46.5054 75.625 43.2963 75.625C40.0872 75.625 37.0095 75.7988 34.7403 76.1083C32.4711 76.4177 31.1963 76.8374 31.1963 77.275Z"
      fill={colors.grey15}
    />
    <path
      d="M23.2754 54.8117L16.8716 56.4221C16.706 56.4636 16.5298 56.4408 16.3818 56.3587C16.2337 56.2766 16.126 56.1418 16.0822 55.984L11.2656 38.6075C11.2439 38.5295 11.2386 38.4482 11.2499 38.3681C11.2613 38.2881 11.2891 38.211 11.3317 38.1412C11.3743 38.0714 11.431 38.0103 11.4984 37.9614C11.5658 37.9125 11.6427 37.8767 11.7247 37.8561L23.2491 34.958"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.2754 49.9679L18.2574 51.2668C18.1032 51.3065 17.9393 51.2846 17.8016 51.2057C17.6639 51.127 17.5637 50.9978 17.5229 50.8466L14.7016 40.3568C14.6609 40.2056 14.683 40.0448 14.7632 39.9096C14.8434 39.7745 14.975 39.6761 15.1291 39.6362L23.2409 37.5361"
      fill={colors.cyan10}
    />
    <path
      d="M23.2754 49.9679L18.2574 51.2668C18.1032 51.3065 17.9393 51.2846 17.8016 51.2057C17.6639 51.127 17.5637 50.9978 17.5229 50.8466L14.7016 40.3568C14.6609 40.2056 14.683 40.0448 14.7632 39.9096C14.8434 39.7745 14.975 39.6761 15.1291 39.6362L23.2409 37.5361"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.1035 34.0986L76.942 36.3708C77.0195 36.3886 77.093 36.4221 77.158 36.4694C77.2232 36.5167 77.2786 36.577 77.3213 36.6466C77.364 36.7162 77.3931 36.7939 77.4069 36.8753C77.4206 36.9567 77.4189 37.04 77.4016 37.1206L73.5335 55.2298C73.5213 55.2876 73.4982 55.3424 73.4656 55.3909C73.433 55.4394 73.3916 55.4809 73.3436 55.5126C73.2955 55.5444 73.2419 55.5661 73.1858 55.5763C73.1297 55.5865 73.0723 55.5851 73.0167 55.5721L67.1409 54.2154"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.1647 36.6768L73.5533 38.1902C73.6226 38.2061 73.6884 38.2365 73.7467 38.2795C73.805 38.3226 73.8547 38.3776 73.8931 38.4412C73.9314 38.5048 73.9576 38.5759 73.9701 38.6503C73.9826 38.7248 73.9812 38.8012 73.9659 38.8751L71.8891 48.8283C71.864 48.9493 71.8168 49.0639 71.7501 49.1654C71.6835 49.267 71.5987 49.3535 71.5007 49.42C71.4026 49.4866 71.2932 49.5318 71.1787 49.5532C71.0642 49.5746 70.9469 49.5717 70.8335 49.5447L67.1035 48.6648"
      fill={colors.cyan10}
    />
    <path
      d="M67.1647 36.6768L73.5533 38.1902C73.6226 38.2061 73.6884 38.2365 73.7467 38.2795C73.805 38.3226 73.8547 38.3776 73.8931 38.4412C73.9314 38.5048 73.9576 38.5759 73.9701 38.6503C73.9826 38.7248 73.9812 38.8012 73.9659 38.8751L71.8891 48.8283C71.864 48.9493 71.8168 49.0639 71.7501 49.1654C71.6835 49.267 71.5987 49.3535 71.5007 49.42C71.4026 49.4866 71.2932 49.5318 71.1787 49.5532C71.0642 49.5746 70.9469 49.5717 70.8335 49.5447L67.1035 48.6648"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.4048 22.9268H26.9741C26.3552 22.9268 25.8535 23.4192 25.8535 24.0267V61.3581C25.8535 61.9655 26.3552 62.458 26.9741 62.458H63.4048C64.0237 62.458 64.5254 61.9655 64.5254 61.3581V24.0267C64.5254 23.4192 64.0237 22.9268 63.4048 22.9268Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.2551 27.2236H31.2644C30.6491 27.2236 30.1504 27.7319 30.1504 28.3588V52.7291C30.1504 53.356 30.6491 53.8643 31.2644 53.8643H58.2551C58.8704 53.8643 59.3691 53.356 59.3691 52.7291V28.3588C59.3691 27.7319 58.8704 27.2236 58.2551 27.2236Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.4785 36.6768C47.1623 36.6768 47.818 36.9484 48.3015 37.4319C48.785 37.9154 49.0566 38.5711 49.0566 39.2549"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.6348 36.6768C50.951 36.6768 50.2952 36.9484 49.8117 37.4319C49.3282 37.9154 49.0566 38.5711 49.0566 39.2549"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.6035 42.6924C39.9419 42.6918 40.2771 42.758 40.5898 42.8873C40.9026 43.0166 41.1868 43.2064 41.4263 43.4458C41.6657 43.6853 41.8557 43.9697 41.9854 44.2829C42.115 44.5959 42.1816 44.9315 42.1816 45.2705"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.7598 42.6924C44.076 42.6924 43.4202 42.964 42.9367 43.4475C42.4533 43.931 42.1816 44.5868 42.1816 45.2705"
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.9087 53.8643H58.2786C58.4218 53.8644 58.5636 53.8328 58.696 53.7712C58.8283 53.7096 58.9486 53.6192 59.0499 53.5051C59.1512 53.3911 59.2315 53.2557 59.2863 53.1066C59.3411 52.9575 59.3693 52.7978 59.3691 52.6365V46.7501C58.941 46.2694 58.5172 45.7952 58.1093 45.3382C57.1118 44.2212 55.7698 43.5815 54.3635 43.5528C52.9573 43.5241 51.5956 44.1086 50.5628 45.1842L46.3162 49.6049C45.949 49.9873 45.4949 50.2478 45.0044 50.3574C44.5138 50.4669 44.0059 50.4213 43.537 50.2257L39.2701 48.4463C38.196 47.9977 37.0238 47.9415 35.9198 48.2858C34.8157 48.6301 33.8359 49.3572 33.1193 50.3642C32.4236 51.3419 31.6729 52.3945 31.0098 53.3298C31.1095 53.4948 31.2436 53.6298 31.4003 53.723C31.5569 53.8161 31.7315 53.8646 31.9087 53.8643Z"
      fill={colors.purple20}
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.3223 33.669C41.3223 34.4338 41.0954 35.1815 40.6705 35.8175C40.2456 36.4534 39.6416 36.949 38.935 37.2417C38.2284 37.5345 37.4508 37.6111 36.7006 37.4618C35.9504 37.3126 35.2614 36.9443 34.7206 36.4034C34.1797 35.8626 33.8114 35.1735 33.6622 34.4234C33.513 33.6732 33.5896 32.8957 33.8822 32.189C34.1749 31.4824 34.6706 30.8784 35.3066 30.4535C35.9425 30.0285 36.6902 29.8018 37.4551 29.8018C37.963 29.8016 38.4658 29.9016 38.9351 30.0959C39.4043 30.2902 39.8307 30.575 40.1898 30.9342C40.5489 31.2933 40.8338 31.7196 41.0281 32.1889C41.2224 32.6581 41.3223 33.1611 41.3223 33.669Z"
      fill={colors.mustard50}
      stroke={colors.purple100}
      strokeWidth="1.22"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
